import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import { StyledSpinnerComponent } from '../spinner/Spinner';

/* istanbul ignore next */
const styles = {
  article: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh'
  },
  section: {
    display: 'flex',
    flex: '1',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  }
};

export function SplashComponent({ classes, stage }) {
  return (
    <article className={classes.article}>
      <section className={classes.section}>
        <StyledSpinnerComponent />
        <br />
        <p>{stage}</p>
      </section>
    </article>
  );
}

SplashComponent.propTypes = {
  classes: PropTypes.shape({}),
  stage: PropTypes.string
};

SplashComponent.defaultProps = {
  classes: {},
  stage: null
};

export default withStyles(styles)(SplashComponent);
